import JassEnum from './enum';

/**
 * type eventid
 */
export default class JassEventId extends JassEnum {}
